const Backbone = require('lib/backbone')
const Marionette = require('lib/marionette')
const getSpotlightData = require('module/user/helpers/get_spotlight_data')
const radio = require('lib/radio')
const { metrics } = radio
const log = require('log').create('try before buy') // eslint-disable-line


/**
 * Handles tracking for an individual pro feature. An instance will be created
 * for every pro feature that a user does not have so we can listen for user's
 * adding the specific feature.
 */
const FeatureTracker = Marionette.MnObject.extend({

    initialize(options) {
        this.user = options.user
        this.is_pro_user = this.user.hasFeature('upgrade')
        this.user_type = this.is_pro_user ? 'pro' : 'free'

        // if this track doesn't apply to this user, return early
        if (! this.isApplicable()) return

        this.model = new Backbone.Model({
            has: this.hasFeature(),
        })

        this.listenTo(this.user, `sync:${options.id}`, () => {
            this.model.set('has', this.hasFeature())
        })

        this.listenTo(this.model, 'change:has', (model, has) => {
            if (has) this.onAddFeature()
        })
    },

    // Makes sure tracking of this feature applies to the user's status.
    isApplicable() {
        const { user_type } = this.options

        // if any, this track applies to all users
        if (user_type === 'any') return true

        return this.user_type === user_type
    },

    hasFeature() {
        return this.user.hasFeature(this.options.feature_name)
    },

    // Called when the feature is added. Determines if the user is pro or free
    // and figures out what event to trigger based on what feature is assocaited
    // with this FeatureTracker instance.
    onAddFeature() {
        const prefix = (
            this.is_pro_user
            ? 'pro'
            : 'try'
        )

        const event_name = this.getEventName()

        metrics.trigger(`${prefix}:${event_name}`)

        // If the user is not pro we need to track a try_before_buy action since
        // the user is entering the try_before_buy state.
        if (! this.is_pro_user) {
            this.user.trackAction('try_before_buy')
        }
    },

    getEventName() {
        if (this.options.feature_name === 'pro_spotlights') {
            return this.getSpotlightEventName()
        }
        return `add:${this.options.id}`
    },

    getSpotlightEventName() {
        const mechanism = this.getSpotlightMechanism()
        return `add:spotlight:${mechanism}`
    },

    getSpotlightMechanism() {
        const model = this.user.get(this.options.id)
        const spotlight_data = getSpotlightData(model.toJSON())
        return spotlight_data.mechanism
    },

})

module.exports = FeatureTracker
